import { DropOffStatus, FormDropOff } from '@features/forms/types';
import { FormDropOffApiItem } from '@features/forms/types/formDropOffApi';

const normalizeDropOffStatus = (status: string): DropOffStatus =>
  status === 'mobile_unverified' ? 'mobile_unverified' : 'mobile_verified';

export const mapFormDropOff = (item: FormDropOffApiItem): FormDropOff => ({
  id: item.id,
  name: item.name,
  phone: item.mobile,
  status: normalizeDropOffStatus(item.status),
  source: item.source,
  submittedAt: item.submitted_at,
  totalAmount: item.total_amount ?? 0,
  paymentOrderId: item.payment_order_id ?? '',
  reminderMessage: item.reminder_message ?? ''
});

export const mapFormDropOffs = (
  items: FormDropOffApiItem[] | undefined
): FormDropOff[] => (items ?? []).map(mapFormDropOff);

export default mapFormDropOff;
